import { render, staticRenderFns } from "./IpsTheme.vue?vue&type=template&id=81fdf9f0"
import script from "./IpsTheme.vue?vue&type=script&lang=js"
export * from "./IpsTheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports